import { render, staticRenderFns } from "./DBuilderReviewerSuccessPopup.vue?vue&type=template&id=6d3801c2&scoped=true&"
import script from "./DBuilderReviewerSuccessPopup.vue?vue&type=script&lang=js&"
export * from "./DBuilderReviewerSuccessPopup.vue?vue&type=script&lang=js&"
import style0 from "./DBuilderReviewerSuccessPopup.vue?vue&type=style&index=0&id=6d3801c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3801c2",
  null
  
)

export default component.exports